import { Button, message } from "antd";
import { useEffect, useMemo, useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useDispatch, useSelector } from "react-redux";
import BasicLayout from "../../../components/BasicLayout/index";
import ButtonAsLink from "../../../components/common/ButtonAsLink";
import FallBack from "../../../components/common/FallBack/FallBack";
import Tables from "../../../components/common/Table/Table";
import { useDeleteAction } from "../../../components/Hooks/useDeleteAction";
import useExportCsv from "../../../components/Hooks/useExportCsv";
import useTableSearch from "../../../components/Hooks/useTableSearch";
import {
	getAllBrands,
	softDeleteSingleBrand,
} from "../../../store/actions/products/brands/brand.action";
import { DeleteModel } from "../../../utils/DeleteModel";
import { formatFileName } from "../../../utils/helper";

const Brand = (props) => {
	const dispatch = useDispatch();
	const [deleteId, setDeleteId] = useState(undefined);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [getColumnSearchProps] = useTableSearch();
	const [exportToCSV] = useExportCsv();
	const { deleteData } = useDeleteAction();
	const brands = useSelector((state) => state.brand.brands || []);
	const admin = useSelector((state) => state.admin.admin || []);

	const permissionArr = useMemo(() => {
		if (admin && admin.template) {
			const { permissions } = admin.template;
			return permissions;
		} else if (admin && admin.accessLevel === "superAdmin") {
			return "all";
		}
		return [];
	}, [admin]);

	useEffect(() => {
		dispatch(getAllBrands());
	}, [dispatch]);

	let dataSource = [];
	if (brands.length > 0) {
		dataSource = brands.sort(function (a, b) {
			return new Date(b.updatedAt) - new Date(a.updatedAt);
		});
		dataSource = dataSource.map((row, index) => ({
			...row,
			createdAt: new Date(row.createdAt).toLocaleString(),
			key: row.id,
		}));
	}
	async function confirm(id, reason) {
		await deleteData(id, reason, softDeleteSingleBrand, setIsModalVisible);
	}
	const columns = [
		{
			title: "Id",
			dataIndex: "id",
			key: "id",
		},
		{
			title: "Name",
			dataIndex: "name",
			key: "name",
			...getColumnSearchProps("name"),
		},
		{
			title: "Code",
			dataIndex: "code",
			key: "code",
			...getColumnSearchProps("code"),
		},
		{
			title: "Action",
			key: "action",
			render: (_text, record) => (
				<DeleteModel
					record={record}
					confirm={confirm}
					setIsModalVisible={setIsModalVisible}
					isModalVisible={isModalVisible}
					cancelMessage="Brands Removing has been cancelled"
					linkUrl={`/products/brands`}
					placeholder="Please enter reason to delete brands"
					deleteId={deleteId}
					setDeleteId={setDeleteId}
					update={
						permissionArr === "all"
							? "true"
							: permissionArr?.products?.brands.filter((item) => item === "update")?.length > 0
							? "true"
							: false
					}
					isdelete={
						permissionArr === "all"
							? "true"
							: permissionArr?.products?.brands.filter((item) => item === "delete")?.length > 0
							? "true"
							: false
					}
					view={
						permissionArr === "all"
							? "true"
							: permissionArr?.products?.brands.filter((item) => item === "read")?.length > 0
							? "true"
							: false
					}
				/>
			),
		},
	];
	const fileName = formatFileName("dealer-brands", "xlsx",admin);
	let downloadData = brands.map((data) => {
		let newData = {
			name: data?.name,
			code: data?.code,
			url: data?.url,
			createdAt: data?.createdAt,
		};
		return newData;
	});
	const handleError = (error) => {
		message.error(error.message);
	};
	return (
		<BasicLayout accessLevel={props.accessLevel}>
			<ErrorBoundary FallbackComponent={FallBack} onError={handleError}>
				<div className="button-style-to-right">
					{permissionArr === "all" ? (
						<Button className="download-btn" onClick={(e) => exportToCSV(downloadData, fileName)}>
							Export
						</Button>
					) : permissionArr?.products?.brands?.filter((item) => item === "export")?.length > 0 &&
					  downloadData?.length !== 0 ? (
						<Button className="download-btn" onClick={(e) => exportToCSV(downloadData, fileName)}>
							Export
						</Button>
					) : null}

					{permissionArr === "all" ? (
						<ButtonAsLink text="Add New Brand" link="/products/brands/add" />
					) : permissionArr?.products?.brands?.filter((item) => item === "write")?.length > 0 ? (
						<ButtonAsLink text="Add New Brand" link="/products/brands/add" />
					) : null}
				</div>
				<Tables
					dataSource={dataSource}
					columns={columns}
					footerText={`Total Brands: ${brands.length}`}
				/>
			</ErrorBoundary>
		</BasicLayout>
	);
};
export default Brand;
